import { render } from "./CalculateNetPay.vue?vue&type=template&id=2260ce2e&scoped=true"
import script from "./CalculateNetPay.vue?vue&type=script&lang=js"
export * from "./CalculateNetPay.vue?vue&type=script&lang=js"

import "./CalculateNetPay.vue?vue&type=style&index=0&id=2260ce2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2260ce2e"]])

export default __exports__